import React, { useMemo, useState, useRef, useEffect } from "react";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { getCookie } from "../config/webStorage";
import { useNavigate } from "react-router-dom";
const numberToWords = (num) => {
  if (!Number.isFinite(num)) return "";
  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const numToWordsUnderThousand = (n) => {
    let str = "";
    if (n >= 100) {
      str += a[Math.floor(n / 100)] + " Hundred ";
      n = n % 100;
    }
    if (n >= 20) {
      str += b[Math.floor(n / 10)] + " ";
      if (n % 10) str += a[n % 10] + " ";
    } else if (n > 0) {
      str += a[n] + " ";
    }
    return str.trim();
  };
  if (num === 0) return "Zero";
  let result = "";
  const crore = Math.floor(num / 10000000);
  if (crore) {
    result += `${numToWordsUnderThousand(crore)} Crore `;
    num %= 10000000;
  }
  const lakh = Math.floor(num / 100000);
  if (lakh) {
    result += `${numToWordsUnderThousand(lakh)} Lakh `;
    num %= 100000;
  }
  const thousand = Math.floor(num / 1000);
  if (thousand) {
    result += `${numToWordsUnderThousand(thousand)} Thousand `;
    num %= 1000;
  }
  if (num > 0) result += `${numToWordsUnderThousand(num)} `;
  return result.trim();
};

const defaultCompany = {
  name: "Suwasthi Intense Healthcare Private Limited",
  addressLine1:
    "Site-V, I-021, Kasna Industrial Area, Greater Noida, Gautam Buddha Nagar (UP) 201308",
  gstin: "09aaycs2840m1zh",
  poNo: "XXXXXXXXXX",
  // poDate: "08th July, 2025",
  contactPerson: "Mr. Ankit Sharma",
  contactPersonPhone: "+91 9876543210",
};

const initialForm = {
  supplierId: "",
  supplierCode: "",
  supplierName: "",
  phone: "",
  gstin: "",
  addressLine1: "",
  contactPerson: "",
  contactPersonPhone: "",
  billingDetails: {
    name: defaultCompany.name,
    gstin: defaultCompany.gstin,
    addressLine1: defaultCompany.addressLine1,
    contactPerson: defaultCompany.contactPerson,
    contactPersonPhone: defaultCompany.contactPersonPhone,
  },
  shippingDetails: {
    name: defaultCompany.name,
    gstin: defaultCompany.gstin,
    addressLine1: defaultCompany.addressLine1,
    contactPerson: defaultCompany.contactPerson,
    contactPersonPhone: defaultCompany.contactPersonPhone,
  },

  transportMode: "BY ROAD",
  deliveryDate: "",
  paymentTerms: "1 month credit",
  items: [],
  terms:
    "1. Goods must reach tomorrow.\n2. Grade A material required.\n3. Supplier to replace rejected material.\n4. One month credit.\n5. Freight included.",
};

export default function PurchaseOrders() {
  let navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0];
  const [form, setForm] = useState(initialForm);
  const [company] = useState(defaultCompany);
  const previewRef = useRef(null);
  // const [suppliers, setSuppliers] = useState([]);

  const logoSrc = "/suwasthi-logo-brown.png"; // replace if needed
  const signSrc = "/assets/signature.jpg"; // using same file as placeholder

  // 🔎 Supplier search
  const [supplierSearch, setSupplierSearch] = useState("");
  const [supplierOptions, setSupplierOptions] = useState([]);

  useEffect(() => {
    if (supplierSearch.length < 2) {
      setSupplierOptions([]);
      return;
    }
    const t = setTimeout(() => {
      axios
        .get(`${apiurl}/api/supplier/search?query=${supplierSearch}`)
        .then((res) => setSupplierOptions(res.data.data || []))
        .catch((err) => console.error("Supplier search error", err));
    }, 400);
    return () => clearTimeout(t);
  }, [supplierSearch]);

  const handleSupplierSelect = (s) => {
    console.log("Selected supplier:", s);
    setForm((prev) => ({
      ...prev,
      supplierId: s.id,
      supplierCode: s.supplierCode,
      supplierName: s.name,
      addressLine1: s.address.addressLine1,
      contactPerson: s.contactPerson,
      contactPhone: s.contactPhone,
      gstin: s.gstin,
      // shippingAddress: s.shippingAddress || s.billingAddress,
    }));
    setSupplierSearch("");
    setSupplierOptions([]);
  };

  //   const handleSupplierSelect = (e) => {
  //   const id = e.target.value;
  //   const selected = suppliers.find((s) => `${s.id}` === id);
  //   if (selected) {
  //     setForm((prev) => ({
  //       ...prev,
  //       supplierId: selected.id,
  //       vendorName: selected.name,
  //       contactPerson: selected.contactPerson,
  //       phone: selected.phone,
  //       billingAddress: selected.billingAddress,
  //       shippingAddress: selected.shippingAddress || selected.billingAddress,
  //     }));
  //   } else {
  //     setForm((prev) => ({
  //       ...prev,
  //       supplierId: "",
  //       vendorName: "",
  //       vendorContact: "",
  //     }));
  //   }
  // };

  // 🔎 Material search

  // material search per row
  const [materialSearch, setMaterialSearch] = useState({});
  const [materialOptions, setMaterialOptions] = useState({});
  const handleMaterialSearch = (idx, q) => {
    setMaterialSearch((prev) => ({ ...prev, [idx]: q }));
    if (q.length < 2) return;
    axios
      .get(`${apiurl}/api/material/search?query=${q}`)
      .then((res) =>
        setMaterialOptions((prev) => ({ ...prev, [idx]: res.data.data || [] }))
      )
      .catch((err) => console.error("Material search error", err));
  };
  const handleMaterialSelect = (idx, m) => {
    const items = [...form.items];
    items[idx].description = m.name;
    items[idx].materialId = m.materialId;
    items[idx].gstRate = m.igst || 5;
    setForm((p) => ({ ...p, items }));
    setMaterialOptions((prev) => ({ ...prev, [idx]: [] }));
    setMaterialSearch((prev) => ({ ...prev, [idx]: "" }));
  };

  const handleItemChange = (i, f, v) => {
    const items = [...form.items];
    items[i][f] = v;
    setForm((p) => ({ ...p, items }));
  };
  const addItem = () =>
    setForm((p) => ({
      ...p,
      items: [
        ...p.items,
        { description: "", qtyKg: 0, pricePerKg: 0, gstRate: 5 , materialId: ""},
      ],
    }));
  const removeItem = (i) =>
    setForm((p) => ({ ...p, items: p.items.filter((_, idx) => idx !== i) }));

  // totals per item
  const totals = useMemo(() => {
    let subtotal = 0,
      gstTotal = 0,
      grand = 0;
    for (const it of form.items) {
      const qty = parseFloat(it.qtyKg) || 0;
      const price = parseFloat(it.pricePerKg) || 0;
      const gst = parseFloat(it.gstRate) || 0;
      const line = qty * price;
      const gstAmt = (line * gst) / 100;
      subtotal += line;
      gstTotal += gstAmt;
      grand += line + gstAmt;
    }
    return { subtotal, gstTotal, grand };
  }, [form.items]);

  const rupeesInWords = useMemo(() => {
    const n = Math.round(totals.grand);
    return `Rupees: ${numberToWords(n)} Only.`;
  }, [totals.grand]);

  const handleBillingChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      billingDetails: { ...prev.billingDetails, [name]: value },
    }));
  };

  const handleShippingChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      shippingDetails: { ...prev.shippingDetails, [name]: value },
    }));
  };

  // const handleGeneratePDF = async () => {
  //   // Try dynamic import of html2canvas and jspdf
  //   try {
  //     const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
  //       import("html2canvas"),
  //       import("jspdf"),
  //     ]);

  //     const element = previewRef.current;
  //     if (!element) return alert("Preview not ready");

  //     const canvas = await html2canvas(element, { scale: 2 });
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //     pdf.save(`PO_${company.poNo || "PO"}.pdf`);
  //   } catch (err) {
  //     console.error("PDF generation failed:", err);
  //     // fallback to print
  //     window.print();
  //   }
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would post to backend
    alert("Purchase Order saved (demo). Check preview below or export PDF.");
  };

  const [loading, setLoading] = useState(false);


  const cleanedItems = form.items.map((item, idx) => {
    console.log("materialIdmaterialId",item);
  const quantity = Number(item.qtyKg) || 0;
  const unitPrice = Number(item.pricePerKg) || 0;
  const igst = item.gstRate ? `${item.gstRate}%` : "0%";
  const total = quantity * unitPrice * (1 + (Number(item.gstRate) || 0) / 100);

  return {
    name: item.description || `Item ${idx + 1}`,
    id: item?.materialId,   // or any unique ID logic you want
    description: item.description || "-",
    quantity,
    unitPrice,
    igst,
    total
  };
});


  // ✅ Create Purchase Order API Call
  const createPoHandle = async () => {
    setLoading(true);
    try {
      const token = getCookie("SWFMSToken"); // or keep it fixed like in curl
      const res = await axios.post(
        `${apiurl}/api/purchase-order/create`,
        {
          supplier: {
            name: form?.supplierName,
            email: form?.email,
            phone: form?.phone,
            address: form.addressLine1,
            contactPerson: form.contactPerson,
            gstin: form.gstin,
            contactPersonPhone: form.contactPersonPhone,
          },
          company: {
            name: defaultCompany.name,
            gstin: defaultCompany.gstin,
            address: defaultCompany.addressLine1,
            email: defaultCompany.email,
            phone: defaultCompany.phone,
            contactPersonPhone: defaultCompany.contactPersonPhone,
            contactPerson: defaultCompany.contactPerson,
          },
          orderDate: today,
          dueDate: "xxxx-xx-xx",
          poDate: today,
          subtotal:totals?.subtotal,
          tax:totals?.gstTotal,
          totalAmount:totals?.grand,
          terms:form.terms,
          rupeesInWords:rupeesInWords,
          items: cleanedItems,
          // items: form.items,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      // alert("Purchase Order created successfully!");
      navigate(`/purchase-orders/${res?.data?.purchaseOrder?._id}`);
      console.log("✅ PO Response:", res.data);
    } catch (err) {
      console.error("❌ Error creating PO:", err);
      alert("Failed to create Purchase Order!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Container className="py-6" overflow="overflow-auto">
        <h1 className="text-2xl font-bold mb-4">
          Purchase Order Creator (Live Preview)
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid md:grid-cols-3 gap-4">
            <div className="md:col-span-2 p-4 border rounded m-2">
              <div className="mb-4">
                <input
                  className="border p-2 rounded w-full"
                  value={supplierSearch}
                  onChange={(e) => setSupplierSearch(e.target.value)}
                  placeholder="Search supplier..."
                />
                {supplierOptions.length > 0 && (
                  <ul className="border rounded mt-1 bg-white max-h-40 overflow-y-auto">
                    {supplierOptions.map((s) => (
                      <li
                        key={s.id}
                        className="p-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleSupplierSelect(s)}
                      >
                        {s.name} ({s.supplierCode})
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="space-y-6">
                {/* Order Info */}
                <div className="bg-gray-50 p-4 rounded-lg shadow">
                  <h2 className="font-semibold mb-3">Order Details</h2>
                  <div className="grid md:grid-cols-3 gap-4">
                    <div>
                      <label className="text-sm font-medium">PO No</label>
                      <input
                        className="w-full border p-2 rounded mt-1 bg-gray-100"
                        value={company.poNo}
                        readOnly
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">PO Date</label>
                      <input
                        className="w-full border p-2 rounded mt-1 bg-gray-100"
                        value={today}
                        readOnly
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">
                        Transport Mode
                      </label>
                      <input
                        className="w-full border p-2 rounded mt-1"
                        value={form.transportMode}
                        onChange={(e) =>
                          setForm((p) => ({
                            ...p,
                            transportMode: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Supplier Details */}
                <div className="bg-white p-4 rounded-lg shadow">
                  <h2 className="font-semibold mb-3">Supplier Details</h2>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="text-sm font-medium">
                        Supplier Name
                      </label>
                      <input
                        type="text"
                        className="w-full border p-2 rounded mt-1"
                        value={form.supplierName}
                        onChange={(e) =>
                          setForm((p) => ({
                            ...p,
                            supplierName: e.target.value,
                          }))
                        }
                        placeholder="Supplier name"
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">GSTIN</label>
                      <input
                        name="gstin"
                        placeholder="GSTIN"
                        className="w-full border p-2 rounded mt-1"
                        value={form?.gstin}
                        onChange={handleBillingChange}
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">
                        Contact Person
                      </label>
                      <input
                        type="text"
                        className="w-full border p-2 rounded mt-1"
                        value={form.contactPerson}
                        onChange={(e) =>
                          setForm((p) => ({
                            ...p,
                            contactPerson: e.target.value,
                          }))
                        }
                        placeholder="Contact person name"
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">Phone</label>
                      <input
                        type="text"
                        className="w-full border p-2 rounded mt-1"
                        value={form.contactPersonPhone}
                        onChange={(e) =>
                          setForm((p) => ({
                            ...p,
                            contactPersonPhone: e.target.value,
                          }))
                        }
                        placeholder="Contact person phone"
                      />
                    </div>
                  </div>
                  {/* <h2 className="font-semibold mb-3">Billing Address</h2> */}
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="md:col-span-2">
                      <label className="text-sm font-medium">Address</label>
                      <textarea
                        name="address"
                        placeholder="Address"
                        className="w-full border p-2 rounded mt-1"
                        value={form?.addressLine1}
                        onChange={handleBillingChange}
                        rows={3}
                      />
                    </div>
                  </div>
                </div>

                {/* Shipping Address */}
                <div className="bg-white p-4 rounded-lg shadow">
                  <h2 className="font-semibold mb-3">Shipping Address</h2>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="text-sm font-medium">Name</label>
                      <input
                        name="name"
                        placeholder="Name"
                        className="w-full border p-2 rounded mt-1"
                        value={form?.shippingDetails?.name}
                        onChange={handleShippingChange}
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">GSTIN</label>
                      <input
                        name="gstin"
                        placeholder="GSTIN"
                        className="w-full border p-2 rounded mt-1"
                        value={form?.shippingDetails?.gstin}
                        onChange={handleShippingChange}
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">
                        Contact Person
                      </label>
                      <input
                        name="contactPerson"
                        placeholder="Contact Person"
                        className="w-full border p-2 rounded mt-1"
                        value={form?.shippingDetails?.contactPerson}
                        onChange={handleShippingChange}
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">
                        Contact Person Phone
                      </label>
                      <input
                        name="contactPersonPhone"
                        placeholder="Contact Person Phone"
                        className="w-full border p-2 rounded mt-1"
                        value={form?.shippingDetails?.contactPersonPhone}
                        onChange={handleShippingChange}
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label className="text-sm font-medium">Address</label>
                      <textarea
                        name="address"
                        placeholder="Address"
                        className="w-full border p-2 rounded mt-1"
                        value={form?.shippingDetails?.addressLine1}
                        onChange={handleShippingChange}
                        rows={3}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <table className="min-w-full border">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-2 border">S.No</th>
                      <th className="p-2 border">Description</th>
                      <th className="p-2 border">Qty (Kg)</th>
                      <th className="p-2 border">Price / Kg</th>
                      <th className="p-2 border">GST %</th>
                      <th className="p-2 border">Line Total</th>
                      <th className="p-2 border">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {form.items.map((it, idx) => {
                      const qty = parseFloat(it.qtyKg) || 0;
                      const price = parseFloat(it.pricePerKg) || 0;
                      const line = qty * price;
                      return (
                        <tr key={idx}>
                          <td className="border p-2 text-center">{idx + 1}</td>
                          <td className="border p-2">
                            <input
                              value={materialSearch[idx] || it.description}
                              onChange={(e) =>
                                handleMaterialSearch(idx, e.target.value)
                              }
                              className="w-full border p-1 rounded"
                            />
                            {materialOptions[idx]?.length > 0 && (
                              <ul className="border rounded bg-white max-h-32 overflow-auto absolute z-10">
                                {materialOptions[idx].map((m) => (
                                  <li
                                    key={m._id}
                                    className="p-1 hover:bg-gray-100 cursor-pointer capitalize"
                                    onClick={() => handleMaterialSelect(idx, m)}
                                  >
                                    {m.name}-{m.materialId} (GST {m.igst}%)
                                  </li>
                                ))}
                              </ul>
                            )}
                          </td>
                          <td className="border p-2">
                            <input
                              type="number"
                              value={it.qtyKg}
                              onChange={(e) =>
                                handleItemChange(idx, "qtyKg", e.target.value)
                              }
                              className="w-full border p-1 rounded"
                            />
                          </td>
                          <td className="border p-2">
                            <input
                              type="number"
                              value={it.pricePerKg}
                              onChange={(e) =>
                                handleItemChange(
                                  idx,
                                  "pricePerKg",
                                  e.target.value
                                )
                              }
                              className="w-full border p-1 rounded"
                            />
                          </td>
                          <td className="border p-2">
                            <input
                              type="number"
                              value={it.gstRate}
                              onChange={(e) =>
                                handleItemChange(idx, "gstRate", e.target.value)
                              }
                              className="w-full border p-1 rounded"
                            />
                          </td>
                          <td className="border p-2 text-right">{line}</td>
                          <td className="border p-2 text-center">
                            <button
                              className="bg-red-500 text-white px-2 py-1 rounded"
                              onClick={() => removeItem(idx)}
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <button
                  type="button"
                  className="mt-2 bg-blue-600 text-white px-3 py-1 rounded"
                  onClick={addItem}
                >
                  + Add Item
                </button>
              </div>

              {/* Totals */}
              <div className="mt-4 text-right">
                <div>Subtotal: ₹ {totals.subtotal}</div>
                <div>GST Total: ₹ {totals.gstTotal}</div>
                <div className="font-bold">Grand: ₹ {totals.grand}</div>
                <div className="italic mt-1 text-sm">{rupeesInWords}</div>
              </div>
              {/* </div> */}

              <div className="grid md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <label className="text-sm font-medium">
                    Terms & Conditions:
                  </label>
                  <textarea
                    name="terms"
                    placeholder="Enter terms & conditions"
                    className="w-full border p-2 rounded mt-1"
                    value={form?.terms || ""}
                    rows={3}
                    onChange={(e) =>
                      setForm({ ...form, terms: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="mt-4 flex gap-2">
                <button
                  type="button"
                  onClick={createPoHandle}
                  disabled={loading}
                  className={`px-4 py-2 rounded text-white ${
                    loading ? "bg-gray-400" : "bg-green-600 hover:bg-green-700"
                  }`}
                >
                  {loading ? "Saving..." : "Save Purchase Order"}
                </button>
              </div>
            </div>

            <div
              ref={previewRef}
              className="p-2"
              style={{ width: "800px", background: "white", color: "#111" }}
            >
              <div className="border p-4">
                {/* Header */}
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <img
                      src={logoSrc}
                      alt="logo"
                      className="h-20 mx-auto mb-2"
                      // style={{ width: 110, height: 110, objectFit: "contain" }}
                    />
                  </div>
                  <div className="text-center">
                    <h2 className="text-[18px] capitalize font-bold">
                      SUWASTHI INTENSE HEALTHCARE PRIVATE LIMITED
                    </h2>
                    {/* <div className="text-sm">{company.address}</div> */}
                    <p className="text-[12px]">
                      SITE-V, I-021, KASNA INDUSTRIAL AREA, GREATER NOIDA,
                    </p>
                    <p className="text-[12px]">
                      GAUTAM BUDDHA NAGAR (UP) 201308
                    </p>
                    <div className="text-[12px] font-semibold">
                      GSTIN: 09AAYCS2840M1ZH
                    </div>
                  </div>

                  <div>
                  </div>
                </div>
                <div className="grid grid-cols-3 text-sm border mb-2">
                  <div className="py-1 pl-1 border-r">
                    <strong className="text-[12px]">
                      PO Number:- {company.poNo}
                    </strong>
                  </div>
                  <div className="py-1 pl-1 border-r">
                    <strong className="text-[12px]">PO Date:- {today}</strong>
                  </div>
                  <div className="py-1 pl-1">
                    <strong className="text-[12px]">
                      Mode of Transport:- {form.transportMode}
                    </strong>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2 mb-3 text-sm ">
                  <div className="border p-2">
                    <strong className="text-[14px]">Supplier Name:</strong>
                    <div className="capitalize text-[14px]">{form.supplierName || "-"}</div>
                    <div className="capitalize text-[14px]">
                      {form.addressLine1 || "-"}
                    </div>
                    <strong className="mt-2 block text-[14px]">Contact Details:</strong>
                    <div>{form.contactPerson || "-"}</div>
                    <div> {form.contactPersonPhone || "-"}</div>
                  </div>

                  <div className="border p-2">
                    <strong>Ship To:</strong>
                    <div className="capitalize">
                      {form?.shippingDetails?.name || "Default Name"}
                    </div>
                    <div className="text-sm capitalize">
                      {form?.shippingDetails?.addressLine1 || "Default Address"}
                    </div>
                    <strong className="mt-2 block">Contact Details:</strong>
                    <div>{form.shippingDetails.contactPerson}</div>
                    <div> {form.shippingDetails.contactPersonPhone}</div>
                  </div>
                </div>

                {/* Items Table */}
                <div className="mb-3">
                  <table className="min-w-full border">
                    <thead className="bg-gray-100 text-sm">
                      <tr>
                        <th className="p-2 border text-[14px]">S.No</th>
                        <th className="p-2 border">Name</th>
                        <th className="p-2 border">Quantity (Unit)</th>
                        <th className="p-2 border">Prices (Rs) per Unit</th>
                        <th className="p-2 border">Total prices (Rs)</th>
                        <th className="p-2 border">GST (in Rs)</th>
                        <th className="p-2 border">Amount with GST</th>
                      </tr>
                    </thead>
                    <tbody>
                      {form.items.map((it, idx) => {
                        const qty = parseFloat(it.qtyKg) || 0;
                        const price = parseFloat(it.pricePerKg) || 0;
                        const total = qty * price;
                        const gstForLine =
                          (total * (parseFloat(it.gstRate) || 0)) / 100;
                        const amtWithGst = total + gstForLine;

                        return (
                          <tr key={idx}>
                            <td className="p-2 border text-center capitalize text-sm">
                              {idx + 1}
                            </td>
                            <td className="p-2 border capitalize text-sm">
                              {it.description || "-"}
                            </td>
                            <td className="p-2 border text-right text-sm">
                              {qty}
                            </td>
                            <td className="p-2 border text-right text-sm">
                              {price}
                            </td>
                            <td className="p-2 border text-right text-sm">
                              {total}
                            </td>
                            <td className="p-2 border text-right text-sm">
                              {gstForLine}
                            </td>
                            <td className="p-2 border text-right text-sm">
                              {amtWithGst}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Totals */}
                <div className="flex justify-end">
                  <div style={{ width: 360 }}>
                    <div className="flex justify-between border p-2">
                      <div>Subtotal</div>
                      <div>₹ {totals.subtotal}</div>
                    </div>
                    <div className="flex justify-between border-x p-2">
                      <div>GST Total</div>
                      <div>₹ {totals.gstTotal}</div>
                    </div>
                    <div className="flex justify-between border p-2 font-bold">
                      <div>Grand Total</div>
                      <div>₹ {totals.grand}</div>
                    </div>
                  </div>
                </div>

                <div className="mt-3 text-sm italic font-bold">{rupeesInWords}</div>

                <div className="mt-4">
                  <strong className="text-sm">Terms & Conditions:</strong>
                  <div className="text-[12px] mt-1 whitespace-pre-wrap">
                    {form.terms}
                  </div>
                </div>

                <div className="mt-8 flex justify-between items-end">
                  {/* Left - Signature */}
                  <div className="flex flex-col items-start">
                    <img
                      src={signSrc}
                      alt="signature"
                      className="w-28 object-contain"
                    />
                    <div className="text-sm mt-2">Authorised Signatory</div>
                  </div>

                  {/* Right - Company Info */}
                  <div className="text-right text-sm flex flex-col items-end space-y-1">
                    <div>
                      <strong>For: </strong>
                      <span className="uppercase">{form.supplierName}</span>
                    </div>
                    <div>
                      <strong>Prepared By: </strong>
                      {company.name}
                    </div>
                    <div>{company.addressLine1}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-2 text-xs text-gray-600">
              Preview: This is a live preview. Use Export PDF to download a
              printable copy.
            </div>
          </div>
          {/* </div> */}
        </form>
      </Container>
    </Layout>
  );
}
